import {useTranslation} from 'react-i18next';
import {useBookingContext} from '../../../../context/BookingContext';
import {DataActions, useClinicDetailsContext} from '../../../../context/ClinicDetailsContext';
import {useSessionContext} from '../../../../context/SessionContext';
import {EidAuthenticate} from '../../../authentication/EidAuthenticate';
import {useEffect} from 'react';
import {fetchClinicById} from 'src/services/api/api';
import {useLocationDetailsContext} from 'src/context/LocationDetailsContext';
import {DropInPeopleForm} from 'src/components/clinic/dropin/components/DropInPeopleForm';
import {DropInPeopleList} from 'src/components/clinic/dropin/components/DropInPeopleList';

export function DropInPeople() {
    const {t} = useTranslation();

    const {
        bookingState: {bookingType}
    } = useBookingContext();

    const {
        sessionState: {userJwt},
        startSession
    } = useSessionContext();

    const {
        locationDataState: {location, locationStops}
    } = useLocationDetailsContext();

    const {
        dataState: {clinic},
        dispatch: clinicDispatch
    } = useClinicDetailsContext();

    // Find first location stop on this location
    useEffect(() => {
        const firstStop = locationStops
            .filter((stop) => stop.locationId === location?.id)
            .sort((a, b) => a.from.localeCompare(b.from))[0];

        if (!firstStop) {
            return;
        }

        fetchClinicById(firstStop.clinicId).then((data) => {
            clinicDispatch({type: DataActions.SET_CLINIC, value: data});
        });
    }, [clinicDispatch, location, locationStops]);

    if (Boolean(clinic?.eidDropin) === false) {
        return <DropInPeopleForm />;
    }

    return (
        <>
            {userJwt !== null ? (
                <DropInPeopleList />
            ) : (
                <main className='main-content' id='main'>
                    <h1 className='people__header'>
                        {bookingType === 'healthDeclaration'
                            ? t('people_select.healthDeclaration_identify_yourself')
                            : t('people_select.dropin_identify_yourself')}
                    </h1>

                    <p className='people__text wrap-html'>{t('people_select.dropin_subheader')}</p>
                    <p className='people__text wrap-html'>{t('people_select.additional_subheader')}</p>
                    <EidAuthenticate
                        onLoginSuccess={({jwt, sessionDuration, tokenDuration}) => {
                            startSession(jwt, sessionDuration, tokenDuration);
                        }}
                    />
                </main>
            )}
        </>
    );
}
